import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ConditionForWork } from './planned-maintenance-library-item';

@Pipe({
  name: 'conditionForWork',
})
export class ConditionForWorkPipe implements PipeTransform {
  constructor(private i18NextPipe: I18NextPipe) {
  }
  transform(value: ConditionForWork, args?: any): string {
    switch (value) {
      case ConditionForWork.EquipmentShutdown: {
        return this.i18NextPipe.transform('ConditionForWorkPipe.EquipmentShutdown');
      }
      case ConditionForWork.PackageShutdown: {
        return this.i18NextPipe.transform('ConditionForWorkPipe.PackageShutdown');
      }
      case ConditionForWork.SystemShutdown: {
        return this.i18NextPipe.transform('ConditionForWorkPipe.SystemShutdown');
      }
      case ConditionForWork.AssetShutdown: {
        return this.i18NextPipe.transform('ConditionForWorkPipe.AssetShutdown');
      }
      case ConditionForWork.Online: {
        return this.i18NextPipe.transform('ConditionForWorkPipe.Online');
      }
      default: {
        return ConditionForWork[value];
      }
    }
  }
}
